import React from 'react';

import Markdown from 'markdown-to-jsx';
import PropTypes from 'prop-types';

import A from 'wanderu-component-react-router-link';

const propTypes = {
    children: PropTypes.string.isRequired,
    className: PropTypes.string,
    displayInline: PropTypes.bool,
    externalLinks: PropTypes.bool,
    overrides: PropTypes.object,
};

function MarkdownContent(props) {
    const {
        children,
        className = '',
        displayInline = false,
        externalLinks = false,
        overrides = {},
    } = props;

    let defaultOverrides = {
        a: A,
    };

    if (typeof children !== 'string') {
        return null;
    }

    if (externalLinks) {
        defaultOverrides = {
            ...defaultOverrides,
            a: {
                component: A,
                props: {
                    rel: 'nofollow',
                    target: '_blank',
                },
            },
        };
    }

    const options = {
        overrides: {
            ...defaultOverrides,
            ...overrides,
        },
    };

    function Content() {
        return (
            <Markdown options={options}>
                {children}
            </Markdown>
        );
    }

    if (displayInline) {
        options.forceInline = true;

        return <Content />;
    }

    return (
        <div className={className}>
            <Content />
        </div>
    );
}

MarkdownContent.propTypes = propTypes;

export default MarkdownContent;
